/* eslint-disable react/prop-types */
import React, { useEffect, useReducer, useState } from 'react';
import { Empty, Row, Col, Space, Table, Spin,  message   , Tooltip, DatePicker, Modal, Tag, Typography, Divider, Button, notification, Select, Card, Popover, Avatar  } from 'antd';
import { Content } from 'antd/es/layout/layout';
import {    DownloadOutlined, InfoOutlined, ProfileOutlined } from '@ant-design/icons';
import { TASK_LIST, TASK_LIST_SUCCESS, TASK_LIST_ERROR, TASK_LIST_DETAILS, TASK_LIST_DETAILS_ERROR, TASK_LIST_DETAILS_SUCCESS, REPORT_ALARM_DETAILS, USERS_LIST, USERS_LIST_SUCCESS, USERS_LIST_ERROR } from './constants';


import { useAuth } from '../../Context';
import englan from '../../../english.json';
import germanlan from '../../../german.json';
import arabiclan from '../../../arabic.json';
import frenchlan from '../../../french.json';
import hindilan from '../../../hindi.json';
import malayalamlan from '../../../malayalam.json';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import AllocationReducer from './reducer';
import moment from 'moment';
import dayjs from 'dayjs';
import Title from 'antd/es/typography/Title';
import { datetimeCovertertolocal } from '../../datetime-converter';
import { BatchDownloader } from './downloader';

let situation_report_pagination = {};

export default function SituationReport() {
	const dashboardtype = process.env.REACT_APP_IDENTIFIER;
	const authtoken = localStorage.getItem(`${dashboardtype.toUpperCase()}_ACCESS_TOKEN`);
	const initalState = {situation : [],users_data:[], details: null, pending: false, error: false , pagination: { total: 0, limit: 10, skip: 0, current:1 }};
	const [data, dispatch] = useReducer(AllocationReducer, initalState);
	const apiUrl = localStorage.getItem(`${dashboardtype.toUpperCase()}_API_URL`);
	const api = apiUrl && apiUrl ? apiUrl : process.env.REACT_APP_CORE_HOST;

	const langid = localStorage.getItem(`${dashboardtype.toUpperCase()}_LANGUAGE_ID`) && localStorage.getItem(`${dashboardtype.toUpperCase()}_LANGUAGE_ID`) ? parseInt(localStorage.getItem(`${dashboardtype.toUpperCase()}_LANGUAGE_ID`)) : 2;
	const langdata = langid && langid ==1 ? arabiclan : langid ==2 ? englan : langid ==3 ? frenchlan : langid ==4 ? germanlan : langid ==5 ? hindilan : langid == 6 ? malayalamlan : englan;
	const settingstimeformat = localStorage.getItem(`${dashboardtype.toUpperCase()}_TIME_FORMAT`) == 'null' || localStorage.getItem(`${dashboardtype.toUpperCase()}_TIME_FORMAT`) == 'undefined' ? envtimeformat : localStorage.getItem(`${dashboardtype.toUpperCase()}_TIME_FORMAT`);
	const envtimeformat = process.env.REACT_APP_TIME_FORMAT == undefined || process.env.REACT_APP_TIME_FORMAT == 'undefined' ? 'HH:mm' : process.env.REACT_APP_TIME_FORMAT;

	const envTimeout = process.env.REACT_APP_TIMEOUT == undefined || process.env.REACT_APP_TIMEOUT == 'undefined' ? 5000 : process.env.REACT_APP_TIMEOUT;
	const timeout = localStorage.getItem(`${dashboardtype.toUpperCase()}_TIMEOUT`) == 'null' || localStorage.getItem(`${dashboardtype.toUpperCase()}_TIMEOUT`) == 'undefined' ? parseInt(envTimeout) :  parseInt(localStorage.getItem(`${dashboardtype.toUpperCase()}_TIMEOUT`));
	// const featuresModule = JSON.parse(localStorage.getItem(`${dashboardtype.toUpperCase()}_FEATURES_MODULE_DASHBOARD`));
	const envdateformat = process.env.REACT_APP_DATE_FORMAT == undefined || process.env.REACT_APP_DATE_FORMAT == 'undefined' ? 'YYYY-MM-DD' : process.env.REACT_APP_DATE_FORMAT;
	const settingsdateformat = localStorage.getItem(`${dashboardtype.toUpperCase()}_DATE_FORMAT`) == 'null' || localStorage.getItem(`${dashboardtype.toUpperCase()}_DATE_FORMAT`) == 'undefined' ? envdateformat : localStorage.getItem(`${dashboardtype.toUpperCase()}_DATE_FORMAT`);
	const pipelineId = localStorage.getItem(`${dashboardtype.toUpperCase()}_pipelineId`) ? localStorage.getItem(`${dashboardtype.toUpperCase()}_pipelineId`) : null;
	const { RangePicker } = DatePicker;

	const customstart = localStorage.getItem(`${dashboardtype.toUpperCase()}_START_TIME`);
	const customend = localStorage.getItem(`${dashboardtype.toUpperCase()}_END_TIME`);
	const [startDate, setStartDate] = useState(customstart ? moment(new Date(new Date().getFullYear(), new Date().getMonth(),  new Date().getDate() - 30), 'YYYY-MM-DD HH:mm:ss').set({ hour: moment(customstart, 'HH:mm:ss').hour(), minute: moment(customstart, 'HH:mm:ss').minute(),second: moment(customstart, 'HH:mm:ss').second(), millisecond: 0}) : new Date(new Date().getFullYear(), new Date().getMonth(),  new Date().getDate() - 30));
	const [endDate, setEndDate] = useState(customend ? moment(new Date(new Date().getFullYear(), new Date().getMonth(),  new Date().getDate()), 'YYYY-MM-DD HH:mm:ss').set({ hour: moment(customend, 'HH:mm').hour(), minute: moment(customend, 'HH:mm').minute(),second: moment(customend, 'HH:mm:ss').second(), millisecond: 59}) : new Date(new Date().getFullYear(), new Date().getMonth(),  new Date().getDate()));


	const navigate = useNavigate();
	const [modelOpen, setModelOpen] = useState(false);
	const admin_roles = ['superadmin','admin','Station-In-Charge','Pipeline-HO','Pipeline-In-Charge','HQO-HSE'];
	const permission = localStorage.getItem(`${dashboardtype.toUpperCase()}_PERMISSION`);
	const {getRegion, regiondata, getUserAllocation ,getUserAllocationData} = useAuth();
	const [regionId, setRegionId] = useState(null);
	const [allocationId, setAllocationId] = useState(null);
	const [showFetchAndDownloadModal, setShowFetchAndDownloadModal] = useState(false);
	const [url, setURL] = useState(null);
	const [user, setUser] = useState(null);
	

	useAuth();

	

	const columns = [

		{
			title: langdata && langdata.Name ? langdata.Name : 'Name',
			dataIndex: 'id',
			key: 'id',
			align: 'center',
			render: (text, record) => (
				
				<Space size="middle">
					{ record  && 
						<span>
							<span style={{ float: 'left', backgroundColor: record.alarmSeverity==3 ? 'red' :
								record.alarmSeverity==2 ? 'gold' : record.alarmSeverity==1 ? 'green' : record.alarmSeverity==0 ? 'violet' : '', 
							width: '3px', height: '40px', display: 'inline-block', marginRight: '10px', marginLeft: '-15px'}} />
						</span>
					}
					<text>{text}</text>
				</Space>
			)
            
		},
		{
			title: langdata && langdata.Activity ? langdata.Activity : 'Activity',
			dataIndex: 'eventType',
			key: 'eventType',
			render: (_, record) => (
				<Space size="middle">
					<a title={langdata && langdata.Moreinfo ? langdata.Moreinfo :'More info'} onClick={()=>{key(record);}}>{record.eventType}</a>
					{/* <a title="Delete TLP Rule" onClick={showDeleteTLPRuleModal}><CloseOutlined /></a> */}
					
				</Space>
			)
            
		},
		{
			title: langdata && langdata.Region ? langdata.Region : 'Region',
			dataIndex: 'regionName',
			key: 'regionName',
            
		},
		{
			title: langdata && langdata.PIDS ? langdata.PIDS : 'PIDS',
			dataIndex: 'pids_name',
			key: 'pids_name',
            
		},
		{
			title: langdata && langdata.Channel ? langdata.Channel : 'Channel',
			dataIndex: 'channel_name',
			key: 'channel_name',
            
		},
		{
			title: langdata && langdata.Type ? langdata.Type : 'Type',
			dataIndex: 'isparent',
			key: 'isparent',
            
		},
		{
			title: langdata && langdata.Date ? langdata.Date : 'Date',
			dataIndex: 'date',
			key: 'date',
            
		},
		{
			title: langdata && langdata.Chainage ? langdata.Chainage : 'Chainage',
			dataIndex: 'pipelineChainage',
			key: 'pipelineChainage',
            
		},
		{
			title: langdata && langdata.GPSCoordinates ? langdata.GPSCoordinates : 'GPS Coordinates',
			dataIndex: 'showGPS',
			key: 'showGPS',
            
		},
		{
			title: langdata && langdata.UserName? langdata.UserName : 'UserName',
			dataIndex: 'userName',
			key: 'userName',
		},
		{
			title: `${langdata && langdata.Status ? langdata.Status :'Status'}`,
			dataIndex: 'status',
			key: 'status',
			render: (_,  status ) => (
				<>
					{status &&
						<Tag color={status.alarmSeverity==3 ? 'red' :
							status.alarmSeverity==2 ? 'gold' : status.alarmSeverity==1 ? 'green' : status.alarmSeverity==0 ? 'violet' : ''}>
							{status.status}
						</Tag>}
				</>
			),
		}
		
	];


	const key = (value) => {
		setModelOpen(true);
		dispatch({ type : REPORT_ALARM_DETAILS, payload : value});
	};

    
    

	


	useEffect(() => {
		if(!authtoken){
			navigate('/');
		}
	},[authtoken]);

	useEffect(() => {
		// if(featuresModule.speedClassificationEnabled == false) {
		// 	navigate('/dashboard');
		// }
        
		window.scrollTo(0, 0);
		localStorage.setItem(dashboardtype.toUpperCase()+ '_ACTIVE_MENU_ITEM' ,4021);
	}, []);

	useEffect(() => {
		if(admin_roles.includes(permission)){
			getRegion(authtoken);

		}
		else{
			getUserAllocation(authtoken);
			
		}
		dispatch( { type: TASK_LIST });
		usersList();
		loadSituationReport(1);

	}, [startDate, endDate,regionId, user]);

	const loadSituationReport = (pagination) => {

		let _pagination = { };
		_pagination.total = situation_report_pagination.total ? situation_report_pagination.total : 0;
		_pagination.limit = pagination.pageSize ? pagination.pageSize : 10;
		_pagination.skip =  pagination.current    ? parseInt((pagination.current-1) * pagination.pageSize) : 0;
		_pagination.pageSize =  pagination.pageSize ? pagination.pageSize : 10;


		let allocationParams = '';
		if(admin_roles.includes(permission)){
			allocationParams = regionId ? `&regioninfoId=${regionId}` : '';
		}
		else{
			allocationParams = allocationId ? `&allocationId=${allocationId}` : '';
		}

		let userParams = '';
		if(user){
			userParams =`&$and[0][userId]=${user}`;
		}
		else{
			userParams = '';
		}
		
		setURL({base: `${api}/patrolalarms`,params:`pipelineId=${parseInt(pipelineId)}${allocationParams}&limit=${_pagination.limit}&skip=${_pagination.skip}&startTime=${moment.utc(startDate).format('YYYY-MM-DD HH:mm:ss')}&endTime=${moment.utc(endDate).format('YYYY-MM-DD HH:mm:ss')}`});

		let config = {
			method: 'get',
			url: `${api}/patrolalarms?limit=${_pagination.limit}&skip=${_pagination.skip}${allocationParams}&startTime=${moment.utc(startDate).format('YYYY-MM-DD HH:mm:ss')}&endTime=${moment.utc(endDate).format('YYYY-MM-DD HH:mm:ss')}&pipelineId=${pipelineId ? parseInt(pipelineId) : null}${userParams}`,
			maxBodyLength: Infinity,
			timeout: timeout,
			headers: {
				accept: 'application/json',
				'Content-Type': 'application/json',
				Authorization:`Bearer ${authtoken}`
			}
		};

		axios
			.request(config)
			.then((response) => {
				situation_report_pagination.total = response.data.total ? response.data.total : 0;
				situation_report_pagination.limit = response.data.limit ? response.data.limit : 10;
				situation_report_pagination.skip = response.data.skip ? response.data.skip : 0;
				situation_report_pagination.current = pagination.current ? pagination.current : 1;

                
				if (response.status === 200) {
					dispatch({type:TASK_LIST_SUCCESS, page:pagination.current, pageSize : pagination.pageSize , payload: response});
				}
                
			})
			.catch((error) => {
				dispatch({type:TASK_LIST_ERROR});
				if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
					message.config({
						duration : 5,
						maxCount : 1,
					});
					message.open({
						type: 'error',
						content:  langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :  'It seems the network is unreachable. Please refresh the application.',
					});
				}
			});
	};

	const onRangeChange = (dates) => {
		if (dates) {
			if(settingstimeformat.includes(':ss')){
				const isoStartDate = dates && dates[0].$d;
				const isoEndDate = dates && dates[1].$d;
				setStartDate(isoStartDate);
				setEndDate(isoEndDate);
	
			}else{
					
				const isoStartDate = moment.utc(dates && dates[0].$d).second(0);
				const isoEndDate = moment.utc(dates && dates[1].$d).second(59);
				setStartDate(isoStartDate);
				setEndDate(isoEndDate);
	
			}
		} else {
			console.log('Clear');
		}
	};

	
	// const openShowAttachments = () => {
        
	// 	setShowAttachmentsModal(true);

	// };
    
	

	const loadSituationDetails = ((record) => {
    
		dispatch( { type: TASK_LIST_DETAILS });
        
		if (!record) {
			dispatch({ type: TASK_LIST_DETAILS_ERROR });
		} else {
			dispatch({ type: TASK_LIST_DETAILS_SUCCESS, payload: record });
    
		}
    
	});
	

	let users=[{value:null, label:`${langdata && langdata.ALL ? langdata.ALL:'ALL'}` }];

	data.users_data && data.users_data.map((user)=>{
		users.push({
			value:user.id,
			label:user.firstName.toUpperCase()+ ' ' +user.lastName.toUpperCase()

		});
	});

	

	


	const handleModelOk = (value) => { 
		navigate(`alarmDetails/${value}`);
	};
	const handleModelCancel = () => {
		setModelOpen(false);
	};

	let contenttext = '';
	if(data && data.details && data.details){
	
		const datetime = datetimeCovertertolocal(data.details.datetime);
		const newdate = datetime.localdate + ' ' +  datetime.localtime;
		// let regionObject = regiondata && regiondata.find((region) => region.id == data.details.regioninfoId);
		let regionName;
		// if(regionObject !== undefined){
		// 	regionName= regionObject.regionName.toUpperCase();
		// }
		contenttext = `${langdata && langdata.Id ? langdata.Id:'Id'}: ${data.details.alarm_prm_id}\n${langdata && langdata.Activity ? langdata.Activity:'Activity'}: ${data.details.eventType}\n${langdata && langdata.Date ? langdata.Date:'Date'}: ${newdate}\n${langdata && langdata.Region ? langdata.Region:'Region'}: ${regionName}\n${langdata && langdata.PIDS ? langdata.PIDS:'PIDS'}: ${data.details.pidsname}\n${langdata && langdata.Channel ? langdata.Channel:'Channel'}: ${data.details.channel_name}\n${langdata && langdata.Chainage ? langdata.Chainage:'Chainage'}: ${data.details.locationDetails ? data.details.locationDetails.info : null}\n${langdata && langdata.Fiberlength ? langdata.Fiberlength:'Fiber Length'}: ${data.details.odMeter}\n${langdata && langdata.Latitude ? langdata.Latitude:'Latitude'}:${data && data.details.locationDetails && data.details.locationDetails.lat}\n${langdata && langdata.Longitude ? langdata.Longitude:'Longitude'}: ${data && data.details.locationDetails && data.details.locationDetails.long}`;
	}

	const filterOption = (input, option) =>
		(option?.label ?? '').toLowerCase().includes(input.toLowerCase());
	
	let regions=[{value:null,
		label:`${langdata && langdata.ALL ? langdata.ALL:'ALL'}`
	}];

	if(admin_roles.includes(permission)){
		regiondata && regiondata.map((region)=>{
			regions.push({
				value:region.id,
				label:region.regionName.toUpperCase()});
		});
	} else {
		getUserAllocationData && getUserAllocationData.map((region)=>{
			regions.push({
				value:region.id,
				label: region.regioninfo.regionName+'(' + region.pipelineConfigFrom+' - '+region.pipelineConfigTo + ')',
				region: region.regioninfoId,
				pipelineConfigFrom : region.pipelineConfigFrom,
				pipelineConfigTo : region.pipelineConfigTo
			});
		});
	}

	const handleSetregion = (e, options) =>{
		localStorage.setItem(`${dashboardtype}_REGION_ID`,e);
		if(admin_roles.includes(permission)) {
			setRegionId(e);
		} else {
			setRegionId(options.region);
			setAllocationId(e);
		}
	};

	const openShowFetchAndDownloadModal = () => {
		setShowFetchAndDownloadModal(true);
	};

	const closeShowFetchAndDownloadModal = () => {
		setShowFetchAndDownloadModal(false);
	};

	const infoContent = (
		<Card size="small" bordered="false" type="inner" style={{ width: 300 }}> 
			<p>{langdata && langdata.Thismoduledisplaysdetailedinformationonalarmsreportedbytheinspectionteamfromthefield ? langdata.Thismoduledisplaysdetailedinformationonalarmsreportedbytheinspectionteamfromthefield :'This module displays detailed information on alarms reported by the inspection team from the field.'}</p>
		</Card>
	);

	const disabledDate = (current) => {
		// Can not select days before today and today
		return current && current > dayjs().endOf('day');
	};

	const handleSetUser = (e) =>{
		setUser(e);
	};

	data.users_data && data.users_data.map((user)=>{
		users.push({
			value:user.id,
			label:user.firstName.toUpperCase()+ ' ' +user.lastName.toUpperCase()

		});
	});

	const usersList = () => {
		
		dispatch({ type : USERS_LIST});
		
				
		let config = {
			method: 'get',
			maxBodyLength: Infinity,
			url: `${api}/userallocation-list?&isDeleted=false&usertypeId[$in][]=4&usertypeId[$in][]=7&usertypeId[$in][]=13`,
			timeout: timeout,
			headers: { 
				'Content-Type': 'application/json', 
				'Authorization': `Bearer ${authtoken}`
			},
			data : ''
		};
			
		axios.request(config)
			.then((response) => {
				if (response.status === 200) {
					dispatch({ type : USERS_LIST_SUCCESS, payload : response.data.data});
				}else {
					dispatch({ type : USERS_LIST_ERROR});
				}
			})
			.catch((error) => {
				console.log(error);
				dispatch({ type : USERS_LIST_ERROR});
				if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
					message.config({
						duration : 5,
						maxCount : 1,
					});
					message.open({
						type: 'error',
						content:  `${langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :'It seems the network is unreachable. Please refresh the application.'}`,
					});
				}
			});
	};


	const getDateWithTime = (date, time) => {
		if (!time) return date;
		const [hour, minute, second] = time.split(':').map(Number);
		return dayjs(date)
			.set('hour', hour)
			.set('minute', minute)
			.set('second', second);
	};





	return (
        

		<>
			<Content>

				<Row
					style={{
						margin: '10px',
						paddingLeft: '10px',
						paddingRight: '10px',
						background: '#FFFFFF',
						alignItems:'center',
					}}
					justify={'space-between'}
				>
					<Col>
						<Row>
                        
							<Space>
								<ProfileOutlined style={{fontSize:'30px'}} />
                                
							</Space>
                        
							<Space>&nbsp;&nbsp;</Space>
                                            
                                            
							<Title level={4} style={{ paddingTop:'10px'}}>{langdata && langdata.SituationReport?langdata.SituationReport:'Situation Report'}</Title>
						</Row>

					</Col>
                    
					<Col style ={{justifyContent:'right', display:'flex'}} span={17} >
						<Row>
							<Col span={24}>
								<Tooltip placement="bottom" title={langdata && langdata.Filterbyregion ? langdata.Filterbyregion:'Filter by region'}>
									<Space>
										<Select Item
											style={{ minWidth: '200px', maxWidth:'200px', margin:'5px'}}
											showSearch
											filterOption={filterOption}
											placeholder={langdata && langdata.SelectRegion ? langdata.SelectRegion:'Select Region'}
											optionFilterProp="children"
											defaultValue={null}
											// value={regionId}
											options={regions}
											onSelect={(e, options)=>handleSetregion(e, options)}

										/>
									</Space>
								</Tooltip>

								<Space>
									<Select Item
										style={{ minWidth: '200px', margin:'5px'}}
										showSearch
										filterOption={filterOption}
										placeholder={langdata && langdata.SelectUsers ? langdata.SelectUsers :'Select Users'}
										optionFilterProp="children"
										// onChange={onChange}
										// onSearch={onSearch}
										// filterOption={filterOption}
										defaultValue={null}
										options={users}
										onSelect={handleSetUser}
																																	
									/>  
								</Space>
								
								
								<Space>
                                        
									<Tooltip title={langdata?.Selectdate || 'Select date'}>
										<RangePicker
											onChange={onRangeChange}
											disabledDate={disabledDate}
											allowClear={false}
											showTime
											format={`${settingsdateformat} ${settingstimeformat}`}
											defaultValue={[
												getDateWithTime(dayjs().subtract(30, 'day'), customstart),
												getDateWithTime(dayjs(), customend)
											]}
										/>
									</Tooltip>
								</Space>
								&nbsp; 
								<Space>
									<Typography>
										<Popover title={langdata && langdata.SituationReport ? langdata.SituationReport:'Situation Report'}  content={infoContent} trigger="click">
											<Avatar size="small"><InfoOutlined /></Avatar>
										</Popover>
									</Typography>
								</Space>
							</Col>
						</Row>
					</Col>
					{/* </Space> */}
				</Row>
                    
				<Row span={24} style={{
					margin: '10px',
					paddingLeft: '10px',
					paddingRight: '10px',
					background: '#FFFFFF',
					alignItems:'center'
				}} >
					<Col span={24}>
						{ data && data.situation && data.situation.length > 0 ? (
							<Table
								scroll={{
									x: 900,
								}} 
								columns={columns} 
								dataSource={data.situation} 
								pagination = { data.situation.length > 0 ? data.pagination : 0 }
								onChange={loadSituationReport}
								onRow = {(record) => {
									return {
										onClick: () => { 
											loadSituationDetails(record);
                                                
										}
									};
								}}
                                    
							/>
						)
							:
							(
								<Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
							)}
					</Col>
				</Row>
				<Row gutter={{
					xs: 8,
					sm: 16,
					md: 24,
					lg: 32,
				}}
				style={{
					margin: '10px',
					paddingLeft: '10px',
					paddingRight: '10px',
					background: '#FFFFFF',
					alignItems:'center',
					justifyContent:'center',
					display:'flex'
				}} 
				>
					<Col style={{
						alignItems:'left',
						justifyContent:'left',
						display:'flex',
						padding:'10px'
					}}  className="gutter-row" span={24}>
						<Button disabled={data.situation && data.situation.length > 0 ? false : true} type="primary" title={langdata && langdata.DownloadReport ? langdata.DownloadReport:'Download Report'} onClick={openShowFetchAndDownloadModal}><DownloadOutlined />{langdata && langdata.Download ? langdata.Download:'Download'}</Button>
					</Col>
								
				</Row>
			</Content>

			

			<Modal
				open={modelOpen}
				title={langdata && langdata.AlarmDetails ? langdata.AlarmDetails :'Alarm Details'}
				onOk={handleModelOk}
				onCancel={handleModelCancel}
				footer={[
					<Row style={{marginTop:'25px'}} key={'id'} >
						<Col style={{justifyContent:'left', display:'flex'}} span={6}>
							<Button  key={'id'}
								onClick={() => {
									navigator.clipboard.writeText(contenttext);
									const args = {
										message: `${langdata && langdata.Alarmdetailscopiedtoclipboard ? langdata.Alarmdetailscopiedtoclipboard :'Alarm details copied to clipboard'}`,
										description: '',
										duration: 1,
									};
									notification.open(args);
								}}
									
							>
								{langdata && langdata.CopyToClipboard ? langdata.CopyToClipboard:'Copy To Clipboard'}
							</Button>
						</Col>
						{
							// eslint-disable-next-line react/jsx-key
						}
						<Col  span={18}>
							<Button onClick={handleModelCancel}>
								{langdata && langdata.Close ? langdata.Close:'Close'}
							</Button>
							{
								// eslint-disable-next-line react/jsx-key
							}

							<Button style={{marginLeft:'10px'}} type="primary" onClick={() => {navigate(( '/alarm-details'),{ state: { data: data?.details, path: 'situation-report' } });}}>
								{langdata && langdata.Moreinfo ? langdata.Moreinfo:'More info'}
							</Button>
						</Col>

					</Row>
				]}
			>
				<Divider/>
				<Row
					gutter={{
						xs: 8,
						sm: 16,
						md: 24,
						lg: 32,
					}}>

					<Col span={12}>          
						<Typography>{langdata && langdata.Id ? langdata.Id:'Id'}: {data && data.details && data?.details?.id}</Typography>
						<Typography>{langdata && langdata.Activity ? langdata.Activity:'Activity'}: <b>{data && data.details && data.details.eventType}</b></Typography>
						<Typography>{langdata && langdata.Date ? langdata.Date:'Date'}: <b>{data && data.details &&  data.details.date}</b>
						</Typography>
						<Typography>{langdata && langdata.Latitude ? langdata.Latitude:'Latitude'}: {data && data.details && data.details.lat}</Typography>
						<Typography>{langdata && langdata.Longitude ? langdata.Longitude:'Longitude'}: {data && data.details && data.details.long}</Typography>
						<Typography>{langdata && langdata.Region ? langdata.Region:'Region'}: {data && data.details && data.details.regionName}</Typography>
						<Typography>{langdata && langdata.PIDS ? langdata.PIDS:'PIDS'}: {data && data.details && data.details.pids_name}</Typography>
						<Typography>{langdata && langdata.Channel ? langdata.Channel:'Channel'}: {data && data.details && data.details.channel_name}</Typography>
						<Typography>{langdata && langdata.Chainage ? langdata.Chainage:'Chainage'}: {data && data.details && data.details.pipelineChainage}</Typography>
						{dashboardtype == 'oneview' && (<Typography>{langdata && langdata.Fiberlength ? langdata.Fiberlength : 'Fiber Length'}: {data && data.details && data.details.odMeter}{' m'}</Typography>)}
						{dashboardtype == 'oneview' && (<Typography>{langdata && langdata.Duration ? langdata.Duration:'Duration'}: {data && data.details && data.details.durations}</Typography>)}
						<Typography style={{color:data.details  && data.details.alarmSeverity === 0 ? 'CLEAR':
							data.details  && data.details.alarmSeverity === 1 ? 'green':
								data.details  && data.details.alarmSeverity === 2 ? '#fa9e0a' :
									data.details  && data.details.alarmSeverity === 3 ? 'red' : 
										'black'}}>{langdata && langdata.Severity ? langdata.Severity:'Severity'}: {data.details  && data.details.alarmSeverity && 
          (data.details  && data.details.alarmSeverity === 0 ? 'CLEAR':data.details  && data.details.alarmSeverity === 1 ? 'GREEN':data.details  && data.details.alarmSeverity === 2 ? 'AMBER' :data.details  && data.details.alarmSeverity === 3 ? 'RED' : '' )
							}</Typography>
						<Typography>{langdata && langdata.EventProbability ? langdata.EventProbability:'Event Probability'}: <b>{(data && data.details && data.details.eventprobablity ? data.details.eventprobablity *100 : 0).toFixed(2)}%</b></Typography>
						<Typography>{langdata && langdata.Resolutionstatus ? langdata.Resolutionstatus:'Resolution status'}: <b>{data && data.details && (data.details.status)}</b></Typography>
						<Typography>{langdata && langdata.Remark ? langdata.Remark:'Remark'}: {data && data.details && (data.details.remarks)}</Typography>
					</Col>
					<Col span={12}> 
						<img src={data && data.details && data.details.activityUrl} alt={`${data && data.details && data.details.eventType}`} align="right" />
					</Col>
					{/* <Col span={12}> 
							{alarmdata.details && alarmdata.details.eventType === 'Manual Digging' ? 
								<img src={mapImg} alt="manual digging" align="right" /> : 
								alarmdata.details && alarmdata.details.eventType === 'Machine Digging' ? 
									<img src={mapImgMachine} alt="Machine" align="right" /> : 
									alarmdata.details && alarmdata.details.eventType === 'Tunneling' ? 
										<img src={mapImgTunneling} alt="Tunneling" align="right" /> : 
										alarmdata.details && alarmdata.details.eventType === 'Vehicle Movement' ? 
											<img src={VehicleModal} alt="Tunneling" align="right" /> : 
											alarmdata && alarmdata.details && alarmdata.details.eventType === 'Drums Beating' ? 
												<img src={DrumModal} alt="Tunneling" align="right" /> : 
												alarmdata.details && alarmdata.details.eventType === 'Clamping' ? 
													<img src={ClampingModal} alt="Tunneling" align="right" /> : 
													alarmdata.details && alarmdata.details.eventType === 'Manual Digging - Deeper (1.5 to 3 feets)' ? 
														<img width="300px" src={mapImgDeep} alt="Manual Digging - Deeper (1.5 to 3 feets)" align="right" /> : 
														alarmdata.details && alarmdata.details.eventType === 'Man Movement' ? 
															<img src={modalMan} alt="Man Movement" align="right" /> : 
															<img src={modalDefault} alt="Unclassified" align="right" /> }
						</Col> */}
				</Row>
			</Modal>

			<Modal
				title={langdata && langdata.DownloadReport ? langdata.DownloadReport:'Download Report'}
				centered
				destroyOnClose={true}
				open={showFetchAndDownloadModal}
				onOk={{closeShowFetchAndDownloadModal}}
				onCancel={closeShowFetchAndDownloadModal}
				footer={[
											
				]}
				width={540}
			>
				<Row gutter={16}>
					<Col span={24}>
						<Typography>
							{langdata && langdata.Totalnumberofrecords ? langdata.Totalnumberofrecords:'Total number of records'} : {situation_report_pagination.total}
						</Typography>
					</Col>
				</Row>
						
				{situation_report_pagination && situation_report_pagination.total> 0 ? (
					<BatchDownloader total={situation_report_pagination && situation_report_pagination.total} url={url}/>
				) : (
					<>
						<Row gutter={16} style={{
							backgroundColor: '#d3d3d3',
							padding: '5px',
							marginTop: '10px'
						}}>
							<Col span={24}>
								<Typography>{langdata && langdata.Norecordsfound ? langdata.Norecordsfound:'No records found.'}</Typography>
							</Col>
						</Row>
						<br/>
					</>
				)}
			</Modal>
			<Spin fullscreen spinning={data.pending} />
		</>    
	);

    
}